export function vues(){
    const v = new Vue({
        el: '#site-wrapper',
        data: {
            nav: false
        },
        methods: {
            open: function(el){
                if(document.getElementById(el)){
                    let elem = document.getElementById(el);
                    elem.classList.add('active');
                }else{
                   alert('ERROR'); 
                }
            },
            close: function(el){
                if(document.getElementById(el)){
                    let elem = document.getElementById(el);
                    elem.classList.add('remove');
                    setTimeout(function(){
                        elem.classList.remove('active');
                        elem.classList.remove('remove');
                    },600);
                }else{
                   alert('ERROR'); 
                }
            }
        }
    });
}